import React, { FC } from 'react'

import { Typography } from '@smarty-nx/ds'
import { TRACKING_CATEGORIES } from '@smarty-nx/tracking'
import cn from 'classnames'

import { wifiCallingBannerContent } from './wifi-calling-banner.content'
import classes from './wifi-calling-banner.module.scss'
import Wifi from '../../static/images/wifi-calling.svg'

interface WifiCallingBannerProps {
  hasDarkBackground?: boolean
}

export const WifiCallingBanner: FC<WifiCallingBannerProps> = ({
  hasDarkBackground,
}) => (
  <div
    className={cn(classes.root, { [classes.dark]: hasDarkBackground })}
    data-testid="wifi-calling-banner"
  >
    <div className={classes.textWrapper}>
      <img
        className={classes.icon}
        src={Wifi}
        alt=""
        data-testid="wifi-calling-icon"
        loading="lazy"
        decoding="async"
      />
      <Typography variant="Base/Body" dataTestId="wifi-calling-text">
        <strong>{wifiCallingBannerContent.bannerText}</strong>
      </Typography>
      <img
        className={classes.iconHideDesktop}
        src={Wifi}
        alt=""
        data-testid="wifi-calling-icon"
        loading="lazy"
        decoding="async"
      />
    </div>
    <div>
      <a
        href={wifiCallingBannerContent.learnMoreUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="wifi-calling-link"
        data-item-category={TRACKING_CATEGORIES.NAVIGATION}
        data-item-name={wifiCallingBannerContent.learnMoreTrackingName}
      >
        {wifiCallingBannerContent.learnMoreLabel}
      </a>
    </div>
  </div>
)

export default WifiCallingBanner
